import { render, staticRenderFns } from "./PartNotifications.vue?vue&type=template&id=6803df68&scoped=true&"
import script from "./PartNotifications.vue?vue&type=script&lang=js&"
export * from "./PartNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PartNotifications.vue?vue&type=style&index=0&id=6803df68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6803df68",
  null
  
)

export default component.exports